import React from 'react';

import { MobilePlanCardsProductsQuery } from '__generated__/MobilePlanCardsProductsQuery.graphql';
import { MobilePlansEditableContentProps } from 'components/shop/MobilePlans/MobilePlansEditConfig';
import PromotionBanner from '../../../PromotionBanner';
import PromotionMessageContainer from '../PromotionMessageContainer';

type CategoryPromotion = NonNullable<
  MobilePlanCardsProductsQuery['response']['eligibleProductOffersByCategory']['category']['promotions']
>[0];

interface CategoryPromotionBannerProps {
  promotion?: CategoryPromotion;
  /**
   * @deprecated Content authorable promotionBanner is retained for backwards
   * compatibility and will be removed in future versions. Use promotion instead.
   */
  promotionBanner: MobilePlansEditableContentProps['promotionBanner'];
}

const CategoryPromotionBanner = ({
  promotion,
  promotionBanner,
}: CategoryPromotionBannerProps) => {
  if (promotion) {
    return (
      <PromotionMessageContainer>
        <PromotionBanner
          title={promotion.name}
          description={promotion.longDescription}
          link={
            promotion.infoUrl
              ? { text: 'Learn more', url: promotion.infoUrl }
              : undefined
          }
        />
      </PromotionMessageContainer>
    );
  }

  return promotionBanner ? (
    <PromotionMessageContainer>
      <PromotionBanner
        title={promotionBanner.title ?? ''}
        descriptionHtml={promotionBanner.descriptionHtml}
      />
    </PromotionMessageContainer>
  ) : null;
};

export default CategoryPromotionBanner;
